enum RoutingPath {
  DefaultPage = '/'
}

export default RoutingPath;
